import capitalize from '@/filters/capitalize'

export default function appDraftType (input: string) {
  if (!input) return
  if (input === 'ach') return 'ACH'
  return capitalize(input.split('_').join(' '))
}
